/* eslint-disable @typescript-eslint/no-explicit-any */
import { camelCase, snakeCase } from 'lodash-es';

type ObjectType = {
  [index: string | number]: any;
};

export const objectFieldsToCamelCase = (obj: ObjectType): ObjectType => {
  const output: ObjectType = {};
  Object.keys(obj).forEach((key) => (output[camelCase(key)] = obj[key]));
  return output;
};

export const objectFieldsToSnakeCase = (obj: ObjectType): ObjectType => {
  const output: ObjectType = {};
  Object.keys(obj).forEach((key) => (output[snakeCase(key)] = obj[key]));
  return output;
};
